import {ToniqButton} from '@toniq-labs/design-system/dist/esm/elements/react-components';
import React, {useState, useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const angelInvestorDialogKey = 'was-angel-investor-dialog-seen';

function setAsSeen() {
    window.localStorage.setItem(angelInvestorDialogKey, 'true');
}

function hasBeenSeen() {
    return !!window.localStorage.getItem(angelInvestorDialogKey);
}

export function AngelInvestorDialog(props) {
    const [
        canOpen,
        setCanOpen,
    ] = useState(topTwoPercentAddresses.includes(props.address) && !hasBeenSeen());

    useEffect(() => {
        setCanOpen(topTwoPercentAddresses.includes(props.address) && !hasBeenSeen());
    }, [props.address]);

    if (canOpen) {
        setTimeout(() => {
            setOpen(true);
        }, 500);
    }
    const [
        open,
        setOpen,
    ] = useState(false);

    function close() {
        setCanOpen(false);
        setOpen(false);
        setAsSeen();
    }

    return (
        <Dialog
            open={open}
            onClose={close}
            aria-labelledby="angel-investor-title"
            aria-describedby="angel-investor-description"
        >
            <DialogTitle id="alert-dialog-title">Toniq Investment Opportunity</DialogTitle>
            <DialogContent>
                <DialogContentText id="angel-investor-description">
                    Hey! It's <a href="https://twitter.com/bobbodily">Bob, CEO of Toniq</a>. I ran
                    the numbers and you are in the top 2% of most active users on Entrepot. Thank
                    you! We never would have made it this far without you.
                    <br />
                    <br />
                    In the near future, Toniq will be raising investment capital for the next phase
                    of development for Entrepot, Stoic, and our minting launchpad. Our top priority
                    is to grow with real input and support from the community. For this reason,
                    we're giving some community members the{' '}
                    <b>opportunity to become angel investors in Toniq.</b>
                    <br />
                    <br />
                    We don't have all the details yet, but if you would like to receive ongoing
                    information about this opportunity, please click the <b>Learn More</b> link
                    below.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={close}>
                    Ignore
                </Button>
                <a
                    href="https://bit.ly/3t8S3wp"
                    rel="noopener noreferrer"
                    target="_blank"
                    onClick={close}
                    style={{textDecoration: 'none'}}
                >
                    <ToniqButton style={{margin: '8px'}} onClick={close}>
                        Learn More
                    </ToniqButton>
                </a>
            </DialogActions>
        </Dialog>
    );
}

const topTwoPercentAddresses = [
    '48527a2aa76342bab25315c141a93952004e8d2814a788ac072f2101ebaf9336',
    '205f80780efc816a6aa8b7952f8a6f8f58a8115c8f814f7a4a7b39236e0c1fd0',
    '36117a4102b241effedeaaf3b7757967f994ec9fdfca1217b307716891ecdad7',
    '5dd1943d29e31697288d07b1d85eed3be8e828c2668ad0291336d9b956ed91e2',
    '15f70665a4e56ee9bbec5eeb4ec3d7fe14b98eff64fa3c3a7a72431304df7a41',
    '8bf177900274c1705555d4a68c81aedaff07c3cdcc15100cdd4c802f9d146a11',
    '82a4edbd08a57f7b5e6b1c63f0430dc559bb7808b28087751fecb006adf8e7f1',
    '76edaadc2a472e2a53e8994f6e318c1e88065c043d4687a9c70942b281ae147b',
    '7fb01a5e86b5919923ab518656c85e361d878e7395b32f7f05a66b5b94ae8cf3',
    '9bd3d71796296e6e735dc54c47d458a80f71c0eff1019b10ae29495447e2f2b1',
    'cf34217e1151dd82dba51f02f2bb341bcd6fefb15c87d470764b5b819eb3154a',
    '21950a5f962128579a503ca4767d08bce9a32b373300dc8e73275da6ead23f51',
    'de70e9f88daeee3f6d429d0f2a91095c16f4bc115597a3c67bb7af56d76dcb89',
    'b99be4a31b592c1092423732cd2d8165369b8f8a8203a26581218a735ec2c8a3',
    '14f8baa65eb528bf5290d7618a05fe83b4da4ac4e7496d829f20d34d69167e3e',
    'b0b2f221e2e017b2969e97a34f72fd752ab03cfb897f31352b9c16aa17bed05c',
    'b42966abb0a643045fbc1ca144b020e2193b808a59ed0326a501eeca06795f3c',
    'bbd103c777b5ad50de82d049c1041e5516a79b9aec94a6365e4bded62ea209a4',
    'a2457c6056d20ceb73e118ebe68ac98da3a179f13c68dfaf73676211c11565c6',
    'ab50417bb8772e4c1b50fe04981140e497d6ea9d6754263c3453c3568c6010eb',
    '3d88ed528b3c672a0eceabcf92e569730243158af9c3777f168ac09ceb96d31d',
    'd5fe80e77a09629f17a1dffc3366cfdfff8b4b721a31fa76d0d7686a00b4ea87',
    '5083135838385ba28cc4c6614674d0aaab070969cc8a8b9937482bd5d4ae16ce',
    'a59335e09b978ab3227e13a056c0bffeb1798968ab28260988ad5eb22fcc2512',
    'e0942307c0a44f9f0d1ba707bee6a4a47dd721f38086e8065070fc8774b8c07c',
    'cc227f48468056ec108c278089e5373ef9e88479644e637c0fafda92c1af420f',
    '70e33273d1c5619c73cd82dff778a66bf2b94d1e619ba1ca944add46dc07a162',
    'd50837a232e4e516d9f58b3e801b54de4d12fd6f4f5538c640be5c1f88107bd6',
    'cda27e7cf67394d383227913a7ebd1d7a39357d9d10500c6633c69f450b0f4ce',
    'a73a2e4f357894473cf2cf5f072dfeda6660a36e700c482c3f82698fa09fdfac',
    '3e3cde8cb66e15af9185c2af2d156a23d49f2d50f237de1fa9a63c810ec6afd7',
    '6f68ae6fbbc8acafede502d3937c17496dbc069766afc5de8f907c13878708dd',
    'dfc4c3d01dbf34c8e7bb2fb74eeafbaf3893a14e2f2b6374de397b920da4950e',
    '200b154a0da363ca3ab74697ce941619d8fda211f6f59741117cb7dc5d65cd90',
    '7c96a454c70330d46c14b3e69c816bc51959b285f86eda63a73c7a282d5cae2f',
    'd57e0e4225ce7c3c79288f85ac8f7c741ddeb98421bfccc0e18c1a15b1e0c7e1',
    '2d00c735893f9746b8f42733f7beee397148becc06408788479ca5d4cef8a660',
    '7778203e952f2a7a86990fc7f8cee48992b5fc0092eb6aa34daa321fda17de66',
    '1e821eb7ff92f65b745afe316507938881bdf653fd4036a1c2ebd66ee7391cca',
    '8ec053ef635e158ff59939102f299292c0d4c3212c1bfb6bbba605ef70a8d9a6',
    '271850ecf8fb39ee92b4005a38b1c9b0f33bee364dd3fcb3cdc94dfcdd6e9c31',
    'ba88258d4b92a041c5dec03e9654c92c3f58213fef6451d70d9b55f664e55ad0',
    '9805ed18d7b85868894035e602e20faad616e3feeed61b5d87fa26f976b37387',
    '8580294a4e45175d1bcca2ffabb5e07e6892731c71e0e8785873b96794398c7a',
    '4ae7f96e7df3009d9356531ddca3a5c9bd4d2d55fce67c9c8c3215b8b1921424',
    '0c44c6d36c773ab90f63ea36e9bd2089b330cbb72430ad4f64fc8a1e133b47f6',
    '4dc51d0373d9c60c3a708ae7cc904c2de4061f6fc09fd4b84649a222acfe63ac',
    'f2730be5d2bfc4e039c74b8e9c9ff38a37e3fd4639c695f12282d98e48e1ba98',
    '8d71d30e5aa78d431f2c39e2a2ad92800709c881641625e44cbacce2ff86822c',
    'e4b405c802fd40be17f7ae41d625bb4d1fe5e030ee45430c79c08e3a345ea325',
    '640ea7b2025bd746cb214a61786de904bd40fd3730a05e34090f1f87866cdb68',
    'c991a7886006a1ef23db2251d25013f5ece994ce1ae20b05e2dab31e9f3e2365',
    'aabe7c870b6af511cff61211a76bf26b51fa6e910144a492fb9b2f435d25edfa',
    '54e25509a1d1b17502f135e1d59a60082187b45852aaecfe7dbcb8639b743017',
    'cc818989e3891971c7ab80a8106265c379b2b228d32295526e928eb4b4c9c86c',
    '3e77b0bbe7b6fd985b73cd11fca64d59db60be8ddfce5446f91ed3c466362777',
    '1939ae0d38e14a78290c822c2d98553fae16fff58fbc8dc48c399d7ae169a817',
    'becad565708efcbeafa2919193792642d94f5dd64428223b5b670f35d35284e1',
    '3e95f5562382fb9a0c2f5eb41f4107d46ffa76256813b803f4168d9008fc4e06',
    '60262f93525e89e70bc1847e7af95dedd76196038b48f1f05b83717525ab4ff7',
    '5605e6d71588d1dcb0d80e0ebf30c0b140cd9c273ce227893941b0a1621d6796',
    '77623f0999459c0b8ef4dd47fdba0e44497f1f7afae6b77dc838d95e4060e6e9',
    'af5c3e7860c49bfc763f61000944256b5b345172729310964972d9ee32f13d56',
    'e75001b78170959550e7943ff987163f9dc164bd88626855abba578befe08fd2',
    '5a392f36f0a524c6138da6a217e209de22e88229ccb5c8fef9a4a28405ebafd8',
    'a22b0fbbb2b6324a0bae51bf7db9936234fc50ee417db50d45e95f9871530991',
    '5d43b0b8b3a236e847079fd8c729ee4e17808bfd8a9f4b31b2c11ae3da3a1c31',
    '78cc47c96b4c2d318002f342fb0658ba4e4183294c0d7f7c3e6489c87d43f064',
    '559c7b7e4f441a63879940321770d1ba3fedce2db7e150f8ab966afcd54b6820',
    '357324b5a09e5690aa8cf8dad490f2dbc368da86d7f98c02dc42aff2f4a01ecf',
    'ffbde6063786c34f0944a995876618e659e45b605a93fb540ba85a5b9b48fa24',
    'a0ab04ab3f32f5b61dca6ac987a4771c9fd5c547d45cfca88a7d4d3295726252',
    '331bbaf28db098965599fa552055cf52be601623c862820926b35a06edb37a0d',
    '70a87f3d2e47f31e5789e1498be4438987fbf0bbf42c6f1772c8d6affe1747bb',
    '2966f5beed45d2cb85f6f93945bc3b6889141626ac1e4c84f2ba0d2703345bad',
    '6fde90e205e782e27b3d45fce30af531afd652d1e4b5e4e02e2ed44269cc4769',
    '1ed14807230b7eace71620b8594f7e9eab3a948d90ecd5ff7c01c7e0ec4b34b1',
    '2e69251787e769295fc5a43183b71b9b47db8d26502148268da133174ffe0511',
    '3013ecb8e0776f6914a216b4ed310447542880c93765818a8dabcbc14c2aa0b8',
    '1215e19404a9b41b1059d38f72b14e5e7bfd1f45d32f9f91024fe1b3c23791b8',
    '1e08685b4a1b6754ccfb91df615fe1389686fd11a0ba411ed68f7b61c04d84f3',
    'ce1ca66fc3a4026587c8f893cbbc6c84957d68586a1df0dcb632780acee8699a',
    '6d374eeae46a5264a62c485172ce2654259f5385e7d8e203246a48170a0e8dea',
    'b59cbc717860f68f4fd84d67827d440fde1d7b80c5c8e5c0bf0bc3599834ebe7',
    '0e21b1c800c2bcb3078feb1d5d1f8c1f239e951948cee8ec96c09a1fe9d7aaac',
    'bf250e230993603877777fb7d7ae4a405194c56fed55676b05c507fdba04a635',
    '6ea8fa5f47460d5f27716d8c4f7079873cde3530bfcc4ef5fb7aae6b33836d79',
    'b0209ff50d8a0d3b2500db74cf81d1e2ef3a47196ba6dc28148ec5878f53fbe5',
    'd877c19bc0bf1bbe76f19da30eb1cc58646f6d055f73331d5678f6a1705466e9',
    '12e08144520424e03bb6866c6221643818c79a4417f76aa7142898938ae4f3cf',
    '2cf1badcd0027e8c534c578b391caaad73e2f1efabde0c62392e4226943c1b48',
    '2c32168791e5c3d6b44f12b00a38e43ac7fc72ec80f8632f9a7a4701a7b23abb',
    '556526a71e306d2438900b7003e8222a1f7376c6535715be248b7370cfff348f',
    'd930337ccee12384f60aae8aed7c1044b856b09cded5b0e05a27303eac61ed2a',
    'aa25466c1cdd9da2fc9988eba24faf6ffea277997ea50651262aac927a50bdd7',
    '3e5bfeb355e39fcf21505a77947359d620c58edd3a8846ac63bb9d70ae20b738',
    '4f9498d627abaa48fc5e313463655fdd77aa8acd2eceeb43b040bcdaf22f484d',
    '524e00c4826491f08d861f5ee4e176d1f3da63f5877e0eeb97d603c50c4d778f',
    '7ecf14801b656e5469860177c75040babd7594669963e3fcd901a723a98bd711',
    '8ecf6db0c71f97542180103b59553c4ffa2d83c8aeff6f06e8c4de92f70ff4b8',
    'b9f9e8ca1d748c8b5319275572cb6ba17e6ca46a75d1c01317316cfb9968f159',
    'af057719365654a14fe45627d28e832a7699672d8f9c4e8daae39749cb0d045d',
    '83cc76dba5ed09250d9bf5f97c68dd5dea609e8d60eeecef0c2cd0f19f2a22ac',
    'f13369700ac3b672adb045969a4dab5da396b6a84836a14b816477bc16bf0657',
    '97a303deba63d964bfb891e9262837d8b862090f600a4aed5e69789ba9a962e8',
    '05633f9295d02e291a00dc63754766aaad52c8ce68ed8309ec7b566921198893',
    '59851c5fdc4e478add558604e37b0b0dc1babda4007eae00a28b35057334519d',
    'a2f4c53fc6621b50899f8252ecad5ba4552236ae9ff51e1dece80ed33821e9e2',
    '48f7a63d82cda1404455bda36918c64cb11978cddbe03b02eda4406a1b0ccf39',
    '541b41cf0e3050e6420a080bd3bdaa1dc1a270e97fd3be1ebae9eef400424181',
    'e1d8cd8f6429b321ae3a4ee5cd7d66779e80595f74a65d760295a9c9fbd276b7',
    'bcc8b08a9b68038d4bc3ed26fd5c9a96dc533b57e8a848e7aa627d0d79404a8d',
    '6dd56d0ccaffcbde74ee179e0645bb32a24f6eb6ac80ec54611462361c97f353',
    '48487ed78901437872d8f2fc5cf1ad64c9cea39b5aa988a25bb690f68b491bb8',
    '8105e7a4cf2e484a09943cc641139f625b0e2d6ab5ff4110a4b2e664cdd00d8c',
    'c2bc2ed93ce277edf6972700fbd502aeb67f0a216bd1da3e519805d1344e6a3b',
    '344a205ea06716edf21467c194821647f7dc9e378f156c30830deacef7e4b62c',
    'f13d6ee1df273daa83c30f8e12c62508fc06f2fb96a150ca61c0f97c1413a531',
    'bd2d8f36f0693c196464d384d4a9a425176b5767d1191d562efc224ea31a97a7',
    '26219409c2635d9bc99d8cbb0e302f7fe022af9e1469fe382b1c3fb6b919b1ac',
    'd6efd493dbac5f808e9ffdcba4ca27caabfb60256f8483e659bb764207d3e05b',
    '65c5f34a3a20d4934272ac64fc48f7791224224c7c0b9166f41b943be8697ad9',
    '3b311dac2f5a6e41a8a6a46d50e663f59ba011b383e5961b6e2f602ae6615e4a',
    '6bf2b451fa42739f9e764d2bad7caef7cbd0f4696b49fd77819a6eb55f1a2e30',
    'cb233652d31b78603f79f6b90ea65d6d217fdafb462aeaf9de12a3958b8dd1e9',
    '3ebd60223028a57b9c439ab880d1c25ffaf22d6cb2a8fcf4db9348d69e33c2c0',
    '4898eee51fd5e61d859581899296a5515b3da88544bbf063eead7f0cb1801db1',
    '0743bdc41d587a9f2bbd0e65467aaa68c813bf7cf5b42ace39de9155941b6330',
    'f2e23e8c97ed09b78b250e0be88e6664fdf98036a04eb52108eea11611ee36a8',
    '8ebeda57d5dce58f9d18c00b7a117471391dd03e25a509c5dd4a51b5cc2ad3b3',
    '2990a6cd67bc28d07bc5f560999fa53a7aca2206835a88f6fc4d27eba9477a6a',
    '8942a79a4cd137c0e979143fdaae45f7da7717f8f0af0c89cab054838367b01d',
    '4a0671f777180efac025a244c0c77a2357e685500ad2debbede2cef6a94a7181',
    'e0df39bd9e458e4954e72ce7b0f35dc4c37bb0411950bb509090620ee9d6f558',
    '2505ab4943aa609c2de2616e336d67c6e63a0d1314f354d72342c34f16bfd568',
    '78e2999bcec6630a9b38800925cb4ab0365bfda7f1fd596e96ddcb36c6fb7c1e',
    'e43b94ccba7e4b61a5cf93d9ea9db93dc8a65c202a42b3dd49b6f45bf31f5f2f',
    '530be304e90945441186fd2a0dc0560ac247352d7cacf6bdc590c51a18fde81d',
    '7917c3a225bdf9b9ff5fde58c6480f6c437c91ba8a228f6ac276805c29c8436b',
    '24d40a7e6ee1e84e3680df3e8f7e938fae3d24c71eb95e231fe91a604aeba475',
    '560ad1bc3c19036d8daad0365322b33ed8f7ce2427748bee172f28ec48818af5',
    'b54f34bf38605f66cf625c5544df702d8d52038072edd344c9c13284727d29ef',
    'c8d5ea6235d299baf416e2da513ee0f1dd1cd077eea37ad41f8e1a3dbf0e442b',
    'e7b55b0cbd73aa180515560fdd59d435d05cc51cc1f97bfede8a507b435aa3b7',
    '0135129fc802ef3be292d9b88f487362cfc9460c1363bb5de31d282ffccf9387',
    '07393d0fe7547f9dfdda2c879c1490dd81675a3d160f9c4940efecbdcb6c11db',
    '6fdab8359964a21ac5b816f4883fc8ca6c23cca15950090788d5470778efb464',
    '4457b46a96abc33daffcaac7111a6b1ac9a40912af5822b8642a3d03b3c0bedf',
    'fb7f1a2fb6cd8b6febe6e08bd065823c335cde75177c58698c6a3820b9a4d843',
    '15995f7756130dea106057830620882969ef89efc6b8c556a05f320ada03b8be',
    '588602f3d1f0fb88ddf2edea02deee92ad1f858594890c5fd6743c4efe391b37',
    'e9208bd5ab932a4111983691d3110bd674ed6156afbf43d36d02674e1bdfa064',
    '58831e30b591b316646a84d08023b44ca1f0ac769da75ae4cb8f270fae9e02c4',
    '4bd3769e57581e3c1ae6a04055755750a936bf14f5f40446a71cd770712d5302',
    '8b2e781f3c8f690284f112ac7fb288c1b140b07af4c312c401d2e71b7dbfd8d5',
    '71e1bc1b70b5ee028539ade4a6c0164188aa69c008577b9ded656b6bc141a249',
    '40cc21a14f6544e00fb296ec9fcfad49f0b36187969ae549da345d701274d439',
    '58d8cc142e5513b4b7d0e8bb15372602f18ae63c00e5dfbe86f4e6c374c93b8a',
    '629da11afbc5a178269828072de5b6daff248e1d160d35883ee6314560a9d3a7',
    'e141214e9d511a8f0fa1dd265b82d98787c0b78073d6cedaab4be34a11154d10',
    'e799fccbba3788aa757f882b766484601ccec362f176a489b2c74361dd2d74f2',
    '5ecf7c976d1dc4b349cd3d267dcb270eab91cfbfe1b7860f99bd0bb184405d01',
    '591946bc18a9b3dd788d9858a7e4cce0a4f85ec484c2b67ca74c79a52374a0a3',
    '1a6d7bc995c967ca30ec6a8b485e6c954baf46aba6595143fb349deaed5b86c0',
    'a4bdc8b257315b52a6e21502540e24b8b5535072cd06c4ec8dc93f8332a73be8',
    '0b927d67d8316ace58aed9e8d7567d4acd4b810cb54aa02ec3a309f9b0417b24',
    '9813f568ecf168015e5ba23f84c55f5474454c45b725778d34b56d4ee8841157',
    '20c5da5e49f3c13798198913c64b2076ebe4ab28fe02341485555e482793634c',
    '89211bf7a4a2a10a44a58c4252f72267d8ca8a09a3da043510e69d428f5b8183',
    '45b58e9c7377083f9a731443edcf6228485ce133a09c477c9b122908892ab9a7',
    'c3125b8208a46cc054831119386d71345f97e2f850b466a233422862b3d2dd62',
    'dbb2cb3000fcbfd1ff337ddc5b5851f41734a5d17c63b67746c9462747f6f4e6',
    '947721c14c37bf4a07cb25233fcef16213921eeaada3ca58d7a345eb8d7f4c79',
    'fcd6e69e42209ed998f04442851bd8d2b217f7fef9e71b2295ef692c1c91b97e',
    '3496ccc519f4f67acbed07b7ab74757da29f720341f14506db945b64c34c5c43',
    'c72db1bcf9b1ce3aae024560a28340903d8b19efd86184ff51c4ce62479cb660',
    'f40194ff972c0753b9e9bda596ece95faf91c821214c8882240d6315d2cc42a8',
    'ee5154288dcb91d9c879d267d034c68139bc8e10a3201a1e46060df015da6ec1',
    '8eaed311f51f1b4089cc1197da9b6a7f321e31f61331c6bcf5ad65acb8429599',
    '3ae265e805e06081c230d82546785731bcd3e3e974eb6b66a753c12aca933fb9',
    'afb264de8057a9ba7f79a51c80f99354004e686bb650172032aada5126e7f014',
    'dcb80153c2925c45833b6a94d7f564d1b52ce02a7082a0705ea8c644279b86d5',
    '35267e873ec29f6aae079f5050995b9a7df87290662e098c34f821dbb02e816a',
    'e5f5fabcc4101cdd4a3e9e74b6ad974a3a7cfe82aaa8d7a5b1a60f9bfd725947',
    'edd79de62be83a1d86b0aa99939d11d9f2c19b91e36532f51824a6891ccc2772',
    'eae28ad374cddea17bfb7c819fe67051b4ccf6b7face8ca2243f683a1489f1a4',
    'c9050b4884be2b9045be8cbb4157b19160775cad17dd9641df0c7740c7815626',
    'ff021988dc4d4fc4b8c33c9143b781824453efb21c709854539d62e918e230f7',
    '63d8e042b82bb0e89c09a1d0867012f48a044306c789d2cdb84fc8028c69443f',
    '5776198e5050e448e224b817d7a4685fb78e246f4c2988a8c233bed45fff5396',
    'd55e56c6cf896ddbfd2b33d06f9a3fcf4e48f0c184aac990f723a111361b16e8',
    '37dd2822378a5fa728e4fbe20d60bcd7df7bb691ee5454bd0a7813a3599fa3e5',
    '353f3e5c3fd7015fe8d93eb30508cfd3304ef409807ff1a5337e4ca504efd352',
    'd333dae315fe666388ab50196a0df188bac7a218763ececfebb180bbfec7dd51',
    '36b4f6cd3266f40c11f0b64a2e091638be63f60f6cdde9227cc103c2eb1019d2',
    '8b5965ade4481f65323d495f693148f7ae27d48ea3d620f2a244be42b6f6415d',
    '87598b7e9ef617ae80959199850615f85616a8ff7078a4e56360ba6a469d8def',
    'd62d787a808dca55197faf0f20aa35be5892d2aad7cd7136c70ad2256f49a150',
    '3ae5f4f296874c82a626cc0ee6cae31d608489e4ac25622a37117a629a81cfad',
    '458b7bcf98e2822fd2daa2be5aa6b642c40f52227420bf8e6665494be712f91f',
    'd2d70afd8554fe7b936710226d608be7e918ee21752c33f2792ca6567633358d',
    '8b1b77d04b7ad442183af9d048cff53dc90b638b754afe08603d3ef07b5b50ec',
    '736a8cf1eb92fe04eca2efa00219c615f17b7991ab76dde965223b0138973312',
    '779ebe5e691dcb80f911cf0daacf859a575a1d6ced1214d1bfad9db4154bc658',
    'b092c864faa50648b87dbb3ee868a792700e8b0dd19e45607d29133335d842f1',
    'bf7815c50f5ece3f3358d1ed119ba4dd89ec1c64a3054a959690895f58cf2424',
    '3a5050c8d638f693aaac6761d5cb513985f1e5280a89f29055184efae0ff69d1',
    'b815d002304d553477487dd48e7e57803bbb5bde51720d191f3e13f6bb79300e',
    '100b83ac9cfdedcfbbe4f61c67cf23ce30ad617c084481f5c4555d2ecb56c2ec',
    'ff18b8930fa0053b61402a4ae5fd68dbbff9888bc5afdbdce2a73c7dfb95c8c4',
    '4e84d8c561dee497e9f66bcb2a9cdca8e7860186d7049ac30e921cb93f9bb2a1',
    '56009b67648295be0719abcfe01ba5dbf62b366c9dd4123863778cb5dfcbdbb0',
    '46528c33c255652663bdf305bf3dde5064df75e0f7a84ca7d5b1f0334ba71f9c',
    '71988b54973c3687840db817ebc6c27e3b6dd7721422d17d0437a191c45672ca',
    'e7efdd68adf84fa811d81038ce6126846cc76f0100f6b883bbd9504bcf3b9879',
    'f7abedebce2a2ef8ed56eb33ca7233952747e48f6fdd5b3e6f912ccf75e90f7f',
    'b03816ea30e9ac8f5186c701d5e6113113221e7298701e3aee5b0874389c3a30',
    'aa073e60b2ab9209202562757d7093f93427874dcda854a352d9f359fa6fb7ac',
    'e7a8a981a29dfa2227e023f3f2e94b5ed216148c6238e8f982307dd653d1bb11',
    '5d8e8995cfa4c99c76729df1faab0c3784eaacbbf3e869db1aae4c97465bc62a',
    '841bb47e41fb760736ad8a2a01a00a8f18e62e1d525c3760e526d743307f7f04',
    '2c6ce2ab894e4e217597fcabdd7f2284dd77bc9bb91573bbaf69619b5f3be29c',
    '21874b081e728ae67fd02772ea6de0126adc3dc2d7d51a4e0398b5945c998765',
    'ac9eb89322f48f73411b429259e98f6c7c64811d4c4c0529491fce93ddf4addb',
    'fe199cf1d998101b05f73b93f5f01ab4b04011da308f5cfb462a3510ee25c50a',
    '904b1eced0335ba7297a56e1fa256318fa31d9d987d4517dc9dc7fcb01c4a0e2',
    '30ab3ce79014b51aef970bf57c38935c53aed1f8c7ed01d806610494d4ee4729',
    '95cb93df8e2b200b16e5956a198be8b03a0d04d4c436edd67309350755b1b4d2',
    'df531e38324b8aed256e529eff465fdba43058c29500bb93cced66daa7db3e7c',
    '3154eb7d22672b3b8ae1c62f9492f2a5549c03670505bae0ebd3ee36bac39e4d',
    'e4ee65fd997382da80c771a976ac13f9828e195be1f92cb0620526bc38f09760',
    '87be113bc35f01ffaa28e7f1582b6cdd9696a5f54d8a83a3a991ded4c7a44027',
    '3b4d5eb7169d680443ed9fcf0d4072c2a0681d364b53cc788ca03a1a37353966',
    '08f2bb21174d495ce7cce449a0245431b3260a5e7200729a069ac49c4b8f0696',
    '4c98f9b42c5aa93c198d9a0374715db6e4348dddf75599636c0204cfe3e1f479',
    'f07142c3caa2c9529ef7fc2c58bdedc800e894579dbfc4b38af2878940463375',
    '9619c14556cbab82ab835218e0d77bc1a18fff5c1ccb62270c856abb602fff27',
    '000cd4fa26b50cfeefd25baffeb2deb756f2ac93727e3752bf6ddb36c44be275',
    'eb84ded44f591b57989b8c5f0a83b2cac79af39034998d1ac3a9ace66c84744a',
    '67e70ee5f77b5f4fcaef4c1b5d9539a8dae1a18b608314ea501ba1126ed1c49c',
    '7caaa9813fdd6afe7c592620cf8fac5fda59c2a7092d9e73b63c994686935c18',
    '4d22aa93b87ae10aa84326952e8aad609df6675fcfcdaee1b00271c8f1612177',
    '069a84c07e55ec000397f2896c04c85f011fcb485f54b55f762de770f9209016',
    '843733196d686db7ea367cfb9a9610c6093803cfac491a6a5377df9d42c34bc2',
    'ecbea6c26d594d3a2b15d4949553928ab588dac79a73cc4f23322557920a56de',
    '5b85bbe6e67a069963fbb95762f5caecd3a7c9388f8abc174ab0ba63cd8b9aa8',
    '34550b162be3b6cd996f171b9350dd8785ed6339580145a47d22dcf71185a033',
    '3e28789cfc4ee34f860d082d62cba86e3f275d5a6f7f3a41e4c33cbaf436ecec',
    'dcea679d3aed819908b9bbea8f363f54a64241631ebd389e9c0138bd2187c06d',
    'd8c14588f95cd4f38bb01382db396b0e44e66e1ad20e5b27db2722d6ab52523e',
    '0a30f95acc63a0aebf1176b3b358f8c415abd7bcfe30b45eb8f8684f05902433',
    '62aaada31ba958f4b8062630ad943c2059d9c6cd13ad942a712933958dd70092',
    '0170fb8ea7801cdf02068804e8ee69d2b35a490f2bd392d8103dc4709eeb0ee6',
    '658645ffab5e404debc0c1f51af04cde5cf04261df74e58c29c859ce1498531d',
    '859356184dcdf39e391f2e7e0606ffa22b5c4e57a53834a490b201da6e0f6ba1',
    '72b19f193600f045b6db22cf9878467551ff308f547d7fbff785d58a835dc965',
    'fb1efa2154ddcd899c6d8bdcb03d61cbc2fe2f425869c06bf70181ae975384ed',
    'f6cd7b988af9f72913ee38a76a8c9aba69e8d92ba7b436df8f39af4943129e40',
    '74e470c0cd4bd98d9e3a3f163719ef83e15f48d14ee91546f846a3f9f9ae0d04',
    '348cbd2a762dcdb9a3d5e46f38ea0dfd37e2e2c0ca78084dbddf8f0705d4010e',
    '5f1f28a589c8a4158327cdc091319d4ca6cfeffc833e493e344f8d4556e0d2c1',
    '3339259957aa809d237afca571d4a597acf424a55a5cf368cc985eeaa8c43f33',
    '53df52c40028aa5f4afc4c9353306873abb2df1e7a68a39102af8403a9b6cb9f',
    'ca53763d7f99c0aaa7bb22a992fcadc54eedb46447d020b2324a67ffeabe16b1',
    'b97a3ffff2662f52aafff4908805941b265afd8b9cfb1fdecee8101483269e32',
    '4624c5bea2c45753e504df76a9eeb8509ea471ad6b2f6f30d114af22ac31d204',
    '4761229f192a38af05c4298a2c2592ad5053ceb0ad78cb249a8ee928f5943c91',
    '46495845866754672a28bf3f1c272e145b04b5920fce13bd18868876313e1605',
    '6564f0e7712df9f57ae920ad44585cd0c401697525bacd83faf23a378c37fd0e',
    'b5c49136ac33abc56c431d4a9b003d77def2838f81a45b158b43b23c09bfa703',
    'fec1c74b3a64d1cdcd7ebce7f89de2d2f563bd119a2952facf8265756a010445',
    'a4ee725cac1e6ba47eb99b0d90b42e33d5400f443b8d72256249dcd969dd055c',
    'bc3dd68be20d228912c6c0064ee0ecf5d990c9b661337758b507a7412774879d',
    '5207daa6bab0944e7568e2e89cbe415a97a454af6bef9c87494b7aa79e8887fd',
    '7552d3701668ab67c3fef81454073544b353bf7f9973d7c5d045f68a890f0ad3',
    '87526e2248daa4b0ce7e19e341850097a58ff787eba41ba14030142c9fcda679',
    'ee8c804d18b388b961aeee08bd45f43ba2a8c16ed48a2425d8f3fcab165aec33',
    'a727e1bb7c06c4bc9efb99826d79c59c6bcae2dacc76858fd438cd427779c5aa',
    'f352b175f7f1f41eef0802907a545e4115508a8a821dd34d54d010ddedf2e116',
    '1869e54207952f62ece24400d082b6c922a81dff43a9ec351299d95437cd89b8',
    '38d0c913eed3c4b2ae366b6f4a2e6e9117b2fd7fc4ce017acd636469b13f5a4e',
    '3f00a1caed00cd13290ce00af07409782e1e271b9f4db25f690fa9227038b38e',
    'd7ed67ecf402312d8751b0e4f8e4e2dd973bdd09e9967a404528bdaad862ba1e',
    'ebdb2741d815cc87b0f5fd71198b44705a0f740fa9d868b89c8c28b002d7e9c5',
    '79906ded2ff592cba65b4475a44a9695cc64b37903232fac0c445c7f1c2a7a26',
    '8ae1d4beb1e46637b34b8e7bec8cf58353be724c692f00f531326e6aa528b980',
    'e5c8dc40979a1c9f8ccfee1cafeca464e12bae9302d39cc62fafdb0def17ce58',
    'fdab27844b32357777a88c87e6bbc0ef8bca9e5ba4b400decb9c889f267de28d',
    'e378e7b78a62d4f27a8ae1da4d90ff7b2b68b296da4cdd0e84747e98d56b36be',
    'b7b3f9db1cf644f9f3db8f6e60d6d9f0527cf51129a551367297ec676faa1395',
    '8598e75d93d8c516b40d50bf4a8a9650b4dd7730c18ba070062a96662a475c9b',
    '162cebbbfd207306b46adddc9e6a0e02b31d47b1ffa2a1072352d3de66c9dacd',
    '2b2a31a973cf7d9e942d28decfce147620f8e20927a17ab9b4ec438c616a9608',
    'c4233ea204b0166cff84cc2422c7d8faf30afa886bd9adbf9fa34f4cda3a28ad',
    '3d12ea1440e0d3196e44d84e7d38038985cdbc23edb090a2a4ff08883bbc0437',
    '5ed361d45b385cfc0051d0b23f90f9dbbaf31bbf477fd680c50291cf660fdf54',
    'ff2ace7f73545ef6b097de325484fa4c070564790b19267776a75f6462258e54',
    '5f7769be12de92eb0ad5b4481ec42c48ff33c152a4c9586e33269362c8f072c2',
    '7ba18d318a52d0adbde26ac3b80c3e685c26de4268218c0f879d0890e4ac5baa',
    'a972168c638e19f41bb7dfb719bca265a1b7332432777e4fa1cf7a659a29c565',
    'a6e48a8939bcf9196c44f75cbc6d291b237fb1f333ff7a5d02ab8b28141085bb',
    '41753943cf2811f4abd6f4373426768b48f5ffcaef31d8dc003af1ae442eebf5',
    '16e876522f46df4e847e4298d008a531739860edb29523068a78f0bac32297db',
    '82d12c0c2215bab02623f15e2f5b58b7c5fc264d80e4ccf5c50bcc3963276981',
    '82925d3230a0d0e3aba1347ef58aa74672bba6666fc5fbed565e5d1f7d583128',
    '1e41f5d0f2c036ec9deb5f9698e673a61771f6ba0be7dadf1d878bd49381d565',
    '339befc720540a70419e723823088520fb67e12abf618b4e7be17a6f41e1b137',
    'b4be27cac04a4e2b2e90ca2f55e033092edf53a67a7ed228044eddb3726eb24f',
    '9cb0db639d8bccb930814df5e31f0a7bbd10b95d57d7311589bf9ba3cadabeb8',
    '3172d3c4cae7c53989efa1a9b856bbbff3ccc1ec014259209c7ddce5a4784ba7',
    '9f73a2c75e42a489578dbba26275f4520b38c990b34e20a9a15e4debfd01c2d3',
    '708b94a55e000cbc9163bf24e462fbe788c32452a13f8484a14280fa1c040fa7',
    'e26227be2d741d579fddd763568c53a11c1ca3c2bfe9422cb08b03f819be6883',
    '3f609ee43bf79b43cf2e14ca6ea992ccf12b8dbd4e280016ec03dd3573456e28',
    '2cb6c992eb0884fbdbb3ff7a6b14d496db0f746049f40ee4387ae038e6608287',
    '81537cf105cf802521bca09a93eb555a685f8f1802f1d794a427983e3e4203a3',
    '03849f6af2b01270c771c070484324631690150f9afb22485bfe8489051ff3b9',
    '6ecdb5bd9ad50391682a2160774fb66fceeb10934f752e489bcacf6a053ac5d0',
    '76fbe4eb8995f748dc1371e2b924e622ac2895c6331808b181c81def73765a73',
    '242b4b9e155cf93c1e472b838bd597c89ac49483a237c9b9dbd7bb7bf1ab66c6',
    'd49012ccd3ff7b0e3efc6137b5342cf7e59095ed2c7703a57605b37669dc019c',
    '36374be7ff30bb6e775009614cbf7bfb7032ea3ce354248291cccb0fc2d68cd3',
    'd1795d19da19987b3ec2dc081e548823e4d6cd3bcb66a8d04674a08685cc6d6d',
    'de82f6c78a20929bd1045ecd84c583d3bc786ffcb5ae8a6ad05cc4872c6b2cfa',
    '799022a0405a4611ea94d6c5672bff8bba016f9fa05018e85e71e14111ab66be',
    'e7c12112448b51f82ce46fc4f66b4ad293258da33f5561438d14f42bac6e8795',
    '300276876905c4c6fcdbe64b103420a96d5eaf2bd2b3045216369888089e7a81',
    '6b736abb179612dd878fa029d03fe97e5bff32b8b4c31be9c450e7c938fee86a',
    'b5e3dc1b2cb8a75bcaa9b160286f56e7b31b5805c083cc6042412f9e80cb9e19',
    'fb0a31b23694a123476a39c6e33c29df634f3869f4d4b8558cfef4969aa822b6',
    'd989e0edbaaace9e9f5d7b6f1eeaeb3243a0944cd2446bbf2c64434eb7a215b7',
    '4d346893947a55c868f17c5651f38be85f30c4cf4be2cc1fb4a2a8516d9b23fb',
    'c9fc66588c46e09420ffe5478fdd84dc96ff145716c161d4e58fbc428435504b',
    '6533df8d7ca760af12bbd2800a84f38c00dd766e41219f898f3470a80a1720aa',
    '5141ee1571633f74a7926ddedec3ae8049c6e208b2f8800022914756ad4780a6',
    '1bda134aa8a3937f51f96f323a67981a2284d665545b1102a90498721e8425cc',
    '4bcc7c3a3a5dae8ad6a96c7bac306421cc903c5a8c28a0db0077203b6f17e33f',
    'e5c4f8163c543ae03111d7c7cb3942e0fbf171679a9f1c4945675d11bf7068ab',
    'ac48165a4f600fc2ed684dcc24182cf66f969da19c32526a9d36ea6a64988068',
    '206f40592d970444f7b87c8e85314e9e33a632fc4b080d104d0764f99497bc29',
    '64db223bb7b5a173ca443f815ee7d9f682d9e29f133440a36d39115b1146851e',
    '31cac7edffcd1ef72f5598014cd0a2f2d9ba8e1f4b4e309a641a736edd424428',
    '6c8ad86a026095db4707a826522be21c367d1b5a7692ca1b36d5f9a5093c7bb7',
    'a95c91172820e274c9914ec69a0980487ed608c365f5cbb812449039d20826e2',
    'c34bd8bb9efdbfa99601e3dfb85c39293433699e603f9fb85e7137c95441e6fd',
    '182a60a4d2b8752f067254f348dcdafcf59a0735117acb176d38f25a9f6f90d7',
    'b956e4a0f64d6f4b4780d7309121f5bb99e26a7e46d5e98337701eef91a366ca',
    '3a4a7d75e61621b6f8c5b27aa74a8d0e0e14476f27febed452554e5fab51c11d',
    'b5ca2629f9abab6b2b9e97ec3efd05d0f042adc78247ad92fbe820281873eed7',
    'd8ecbcb249baf2c51324fbd306390838dbb118cee12f5c766fcdf0730db7b152',
    '27d26ccaa4975ce01b4ea5fd4681c7c1bde211506c5069ec0416773acb0fbe7c',
    'd24e01491766b6fe9ff78860af3642df3e80748a0db6fcd843d1022dce274fc2',
    '4b13222cca9dbcc157400ea4b62a41c164e3f404250d32cd32b08e0c768d38aa',
    'b47601fffb6952129d143a1ade778dc477004e76617f160a9493b8acb480f981',
    'af39b325a36cfa03d67cfa715e8b1c474f2beb5dcccbca5b1cabbe7cb04f6b8a',
    '276151050d1d0c08bcc9cd77ba22d220ab46f690477d73694c26ec3a7781d82a',
    '8b5c43ffc9a12ac17b437801a6f345d0bd406b21213bd35175553242028fea99',
    '4b38ef37df2842eb354241428570725ad394c5cbce3f53bc150aa5845cad7578',
    '4a411ff180a2a2e098d673624678dfe13ffbc926d538587e3444aa024d5e4064',
    '30d08d681dec813f78f736f3e9d1b5894d8fb1009d88ab6ac4af0cafa2df95f9',
    '724d0aadf8de7351661227f90384861a8acdbab76de7c20f943c690e30d01c42',
    'b28ecb5c53f5e7fd259642c2c2941f7db1fb51a0170d8e5e348dd8b9141309de',
    '25b3234c5b1d40ac38758db74e68565e9b477f6e919fc596f77b1a3bf656a926',
    '88adfc453e54f3d6c35d6978d763403d3606aa65761f869aaffa33763973b242',
    'dfa44d9f442bfe1971954d3576fc4743a7cf94496d1725ac96645e4d2f7a6163',
    '0a1970c37cbe6a47a67f53dfb8f921e3f46c6f01a5e00c33c68643795ec62900',
    'f4c8f947ad0588a7a4a07e47f3f3d5562b934aa21a7c33be0fb1b49fee3e9409',
    '41de038d20227fa6bb6f21aa00da8e718c1c7930d4db81a5a0ccca258ee6f3ee',
    '6e8c68ac947d6d42f6fe3bde87672d9cea43c1e851de7bad1f013913bb23315d',
    '58ba22485b469d71b91714faf83e1d7943c5642c0e67a81c1b12aaadc135661a',
    '93cf58f89a5660c7e3be7ed3b550c6ee3d7830d274f44d2ba88d90db8d006698',
    '89059bce14e957ceb42e613c9623c53fadc9983bba44cc665d0806d11d0c6122',
    'acc899f0d9ea43ede30547e302e5fca7d0cdf6b1e087f19f496c7dfc55fe175d',
    '8ec7fd37c6a0b3815f4e2fa571556609b3168510b3b57a702da30aafe23b1bad',
    'fca5e441bc3d5969b5282c8d0c7f440512de7f70b7a6fd78e6ee150b5b18d951',
    'cd6cb2880fb484442abeb9da3a7655d221fb4d81e4fc879eb10e43b5e18d6d7b',
    '9e6edf83306f075298e0a361f36e114f89f8763f694a980b3d2b0425ad7a2041',
    '91a1ce2949fdb9f7944fa6e6da6b3fb914ecfdf9d4e24ba34911e4d042c6a076',
    '5bde61595756370fd10a463e6854459de1a96c22cafc988feadb96c7f39777a5',
    '178469345a47d70aaeea49189a814467c3a8f740db88c19d6fc1c4d2867dc235',
    '7eddcda220b7425b503ae35d379b65f6fa4208ceb5839139595db6cf026eca56',
    'abcc9183600d50e9ed8ad97f043cb707d708bf943d9ca71b03fd90444e794c62',
    '1e59638f75805f868b08c21adcb39ec22b04f79c27d44c1a6d020b9208930c43',
    '743b072344a6e2ecb43c5a7b2cd84cc2cdfbec2f925784cd890e74645748d1b9',
    '73591e1194e9080db061faafc0fa5956ef33c9002755303c185fff3aae49c3ff',
    '07deaeb2a584aa38851e7ddecff3fbf75e7172f1e7c6a15ad01c317ee226f32e',
    '6f0f4acc56b36689ad3b1063b50200a05ab4b5171d57f8e6ead365ba49e43c8f',
    'a4c5324c3889b87255921547f49df006c10bcef4df9d871a3067bf4a9216f11b',
    '52aee3426de2139f251e5504b72c78747f73d1c03511e4a8998746c97f37d3aa',
    'bc55a00af139f8eca1977b5ac38140fda7f4610d6d48ffb181dd8579571c33d1',
    '3369a46f14ed50fc9c5964d1470a2b8d50c70b40048613da4d08a8eb1f6870a1',
    'e7c162fdb6748c65bc6458d07eb127b2d877f48890e49ee04d8e77b38a76d697',
    '0b79f7ff16b8241fa5529936becf77c52ecb75c5db3a1dbbeff1aa71c44f40ec',
    'c70188c5279e8ff4073e09c301579c420b1c87f80ce4548504fa484c01d18bc4',
    '67f386271bffec2cf91adeae355a80018a0cc2042c085bddaca27ecc774003f8',
    'f6f52e57cb178063899b8b6518aebe700ca724576a6da6f30f4eadf9f5b591e4',
    '8911e50477db04ee96be81130a226f11aaced4adae3f46db09768a7b9c327469',
    '9b4b32fe9d4fb7724e1780e2050a5fef0454a9eb56d67a7079be931f3b2560da',
    'b7b53910c7e348763f62d30cc94ae0390eabc1b8633fa84025effe445b5206f1',
    '279aac813327aad198ae8f2379458f43daf1a8e495728445efa88d498380e126',
    'faeedf0643f0ed8b902bfcf4f278f43c8b5d8457371aa927326845c9cc3df766',
    'cfc60c7a023f63362182440930c5da9accd8d4e392bfe18d45a1ccd9100bc511',
    'ab755cef00f9c034221806160a7fcd4cd712720eb9c9b1960475e3068ef2b494',
    'e406e6e749189e29edd5362d0f0a43d1343bd3761e3ee2da4358b4ffa86b50db',
    'cdf3277dcfd7beb5fe8cfa54f50885fb9bf59ef26774ad4e59ed6276bdba203e',
    '4b0019a1518f4f518370cf214b8f89cae0ebcd8cb3bf2d323676db46c0f36b5a',
    'b219a4c1ea372beededaeaab08a9244f7c701cab3f571457495d609dbb78a1a2',
    '73c57c23f3bbea7ea2c649a25704a038314d02005a90a75daac991ffa3536b90',
    'f028ef084f00db8bd7f0539ff5b41abc80f0c1ac587b4fdb449e8df2271eb411',
    'eb9e8e6131606ddc86e622d6b7954c779fe78be4840a396dcf74c12453c59165',
    '6bd13d843c3909709904f00813f4e56368bae92f6e0886b8461bacfc4fa8127e',
    '82717670ba5738cade8907afb3cd1ca1916f8b9e4b028ba67695a7ecd80e2771',
    'fd2b425351b2a070a9aa0159b2f3dd845f77da0821a50e013a927ba69d76e09b',
    '1e1e8980cf256afecabf64bbdf37b8086d2ca8f5dd89bf635f6136513aa298e9',
    'b5de44514088a08f608e3c5ea39b48d92a13aec53b74a5eeb2d4f3e0ac83458f',
    '23c2954703a2e6843ef085f8d529db94e0c9d6ed0361e01308b83e9828346baa',
    '65c3376ec982ec0120b9b0becef8e0ed355de51be9a463e58f5c3e86ef1aab85',
    '59f16a42d6ac8c9bbdc0459a282f916285fba1e64e6cd49d0e8c2ada756df8e4',
    '443c1e72487144e30505eb50f1134ea209bb57cb038f26bee139cf746ed90868',
    '0fc551357987a9380b6680e6a7675c2831b00c950ea6b7d3f9374ae5e94023fc',
    '7c45eb9fffaf44589ac7d2edebac87f340723d035d20ecfdf4fc931a20676103',
    'b6af8515fb86d1b9e609a4934dfa8214d917e4424e48ac7f0799587d660dcf6f',
    '59c2d99eeee43761850629e5cbc00f897b0bf039f29536aa0f066ddddd858108',
    'a78bc3f6257a9841d38f4ba00a4efb3c24cf5bce2887d4780bfd7d213c25d981',
    '9a5592f347844ce73a5a5555858566af8e5131b0d58f16ffc998c69149864777',
    '40d3a835aa5109111a06d2838f77d062259438ee7ec7936d5f02199bb5154d81',
    '15e1bdc72a03201d3890579d2ee9bc2d085cadc825d2406f775154729037b514',
    '4ca972b94f1d65ee6e1cd7cbd7fd54d131cfcda0ccaff42d04ac17ea13c49650',
    '0c16f57c0dcbe63bee210ab9faacd41f1817d9f19ff0cf283aa482ed9e0a7f56',
    '651f209302d3035b9f0dfd9372ccdb77a30f4ede68bdf91301d99e3c4f7d37c3',
    '0b4438f77bff6efb6f8628e4c8b6a86d48772221e9953ad17c943e1defb15eb1',
    '3452b6bb00a5c7c266c7abc2bdda234a0e7c6aef6794e0f823df024daaf05018',
    'e37370de5446dd51858f139b95083ac20364bbbe1e76d5b4cb1d2f530664434f',
    '82336f61bc318510037c7135c446ed481f5d5a77f25f249e7bde25aa9ae26814',
    '48f170e6841079a6066b755e0f7b3d540fac9abd954dc00cf0ec8b758eb6bcb6',
    'b2417afd245f4fe1c38601b288df0167918170e6156b0416422a57122b60532c',
    'e913cb9bc367230f2dbafb8623d9e03516aa40dc68dd5ecce9805f35717db66a',
    'dffc6d172c32ce28ddbb38ac9dd4760dcd375f06b78308eb2b35be9176f7026c',
    '3c77304a9eb289a4f35c10058b0a114b5eecdb93f1d2201b54a9a6b10ddf4539',
    '2047f0a78a61f979cb6a1a0ddd59dfbe6fcf1ec1221dfa28ad247704842583f9',
    'caee4fcd0ab91d87e8f2e53259c10472d981972f493584f4072bb311e11ef6b4',
    'b63885742b082b788f8dc7c495fbf44ac0c4d7ad5dd00890b639dbb37ee35221',
    '2ea4635f076d902644440309bbaa764f8940b341acdbffdd2ab2b94009e181f1',
    'c8acfcce02c69a4aed6384f93791a25d1431d7c3626a4c041784b58670086ad9',
    '5e6c6e7fe2dc272b5b75e636c82fe187be9c46eb3dd81b896a1eef537c37fdbd',
    'de8563e32697593b53be399bb738de072c5bd76df0e56520b4db115f9300295b',
    '0dd9d2a1e44483495d9e31cdc4531d07ac57a9aa6327d4e04b1bf4208339f612',
    '0cfb359661b97ec1704640795a7e9cfed7361635215df0c0a129fe8a8da44fd4',
    '29d2cd931065cf3be11a93d218133bfa1bbed11586cd5f924bc1105f20fd0d6a',
    '238b3f9aa95a8564b8de709a2b3f7f90d07f90e1c0d6ff9342c56e75a5f88c9c',
    '4db213a4c511a635235da06a60bd13d20ca1206dfe5ba7ee1c147cff0acae43a',
    '65a4cff132840e96faf8245afdff8260093ca61e2ebd95fa227aeb4e95736288',
    '50b433382653b23f1505f1d9359405cb71158fa9ef524fd54dc76714c40184b5',
    '369ca2f0e3d87cc40129003afe1df596ef4511afb707e2ea063aa09f8dfcea51',
    '415873e3f504032f01b52febdd0734dba6603b3ca101e92c2665cb323893342c',
    '09792fd06fd0c2ccc0fb0b8bdc9b2ceb1a4c84b99cc68e4c712ff975a249e425',
    '4f0a40f1e24fdac90cfa87d7a0a3427aea78dc0cd6b046ba3497689343a2852b',
    '781cca0b42bf1fbdbb01fe1bee0a2679b298de00c9a813471ee1aaf45db51c07',
    '353e1fdfaae26de8c014554f31274b2e845c0b3babeb5f702b71e507703bac05',
    '3f05ed02a04b765d5d20193d3c290b22578248880627c506c7d3a77213e48f7f',
    '8f3e4306f7768c59ccb7b4480e893b24f905a21fed0ee0a019dbed2c1d9355db',
    'b0237c9872f84a4dbc30c3ee18d583dfa2ca84086ff3a50660dce29b93a46792',
    '8e3025cf2edf9cf2a6043e40d440d72d853d81338f46ef7e14881eda0b8faea2',
    '9cf1cfb010ea423953d0cdb1dfbd6211e76876a8393f4fa81752df9baaeb13b2',
    '26a86bd1ee718e81218d9b029a5df7958021a4ea1dc3df871acf6f23b9d23004',
    '84faeda4633d53c8b4ffc1f1050b7f33b8f6adb8cbada422f9a57a8db615b5fd',
    'fe3811198605d53c5fddcd26ae4482a61bde19440c8a3c2c2b235b385a0dc7ba',
    'f6177c4834330f1b958c165750e90e56960a71e4e8c78682bd9b2723918f1009',
    '725330a2f9b046386f4b115f932075fba636ef3739d1a654118ea0f46f89446e',
    '33447c8ad9dbafa5a24300c667f63ef0172302cb62b5f12fe45a0b93849802ae',
    '2ed12c97be419a0d75c23ae0df03e402ee98e8cd7a9d7661e7efae31f61e195e',
    '9bea3cea107cee447b950c38da8f2df4f7295e081e211ffc32b9d98d197d75bb',
    '6ac89d0ee05bb8b102490a0ffdc3ff46744e61ed8131cdaa3a08319592187ae8',
    '4a66eed26601245b3c3c90578aee7c547399619ffdf99d83599109b592a6e33b',
    '09e3ca1d8f6231dfe26850103546583d20759a046b7fcef05d392ee01699b8de',
    '2d08d0af6ffd5b33d349acb098c8b81a072e072453c778b7c7c68e0ba0c04b45',
    'f390a5dc7103c4011442073809d45cee04b1245d7e2c136472254e30f734165d',
    '1211b5b39fd89a1e4abcaa74838cd1832c5081a7c204a0b0a21dac5963b7520e',
    '942aa19a8938960f737e52f9935e7320c9b5eef7f9ef19b97c70359690f20957',
    '7ed274485973a7f234f190ec30b7553b39a39f3e888b5b5fd7766f15730c2575',
    'd622e14a782b7471d239a36b3837e811ad4bcde4cfa6d71a8f04bb1555e95ed4',
    'b8fa102ee3b5abe25d99e16fa9c5aa8be3ecd327409029f5911ea70e5afaddd3',
    'ec7cf59c00e4f622590e4f829046ca1cd72ee64b354a7864e09a846dff425b5b',
    '46b1e60811e6455d07a16611bf7c5ad43234195cb367d82a4b5dedbd50ecf224',
    '4e2926fbdaadf155a9a9350e06787f59403bd45d416ce32f8b87da5c5603a64f',
    'a652a7a396f2905e5240f673f7c34b87975642ff4a731a27bb460f4dbb3977ef',
    'acd50fe26a641d46757ae1a11fbeeb9a7c52bd40f388b060ed46d199d9d8db24',
    '49a3a73fd85a379f405a2c52f7ca12c8ec6941359aafca579dffb8ccff29076e',
    '1f92373a38884ee5849e9fcd92e42b1741e1dc8b7f103a40a41ffb5f9b052d4c',
    '4d2f205b1d76de3c6c79b750cd8ec3284e6a9b7ce88615c78b7c272613e23d60',
    '820d2a3175423717082fb67245306f81090e79132877585ffb3d4e95db8a1f86',
    'a340fef1b0a01640fc7e04d898e93bb7a069cd63bdf71e9384b45c9726f04f0e',
    'e7755d47622801e282152faf19fd7abc0e66573570d031840a322f2dcdd20462',
    '2c12d83d4129ab0de217357259023c65c028f95ee83e23bd5933c7e746dfca0f',
    'ee0ac3407c04ebad85e6cff016a12bbeee99fabe345b69bc2bb72ce6fcf6e168',
    '1da1fe2ddc373c852743df56519efb6d07afd26cb9d57d689c05a2c05e5b6185',
    '62352f90c5acab0fc6abecec1c59bb1c910f797185669e86622333fcf0b7bd80',
    '38c7f947e719644964a74a6359f6ee673db7a7c866ee2997e04d3fae1a2fcc8d',
    '5a9afd7413bdb62a19864ef4d2e93c9118a112888ce812c00c5424bdc00b2cad',
    '46fc5cdd21f0b9f14b40383a47b5c0930788fdb4018c917b0a1716b83670870d',
];
